import React from "react";
import styled, { keyframes } from "styled-components";

import breakpoints from "../../../styles/breakpoints";
import { WineCardPreviewImg } from "../WineCard/style";

const PlaceHolderShimmer = keyframes`
0%{ background-position: -468px 0 }
100%{ background-position: 468px 0 }
`;

export const AnimatedBackground = styled.div<{
  gradientStart: string;
  gradientFinish: string;
  borderRadius: string;
}>`
  animation-duration: 1.25s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: ${PlaceHolderShimmer};
  animation-timing-function: linear;
  border-radius: ${(props) => props.borderRadius};
  background: darkgray;
  background: linear-gradient(
    to right,
    ${(props) => props.gradientStart} 10%,
    ${(props) => props.gradientFinish} 18%,
    ${(props) => props.gradientStart} 33%
  );
  background-size: 800px 104px;
  height: 100%;
  position: relative;
`;

// Add a padding around the image which should translate to a 85px padding in a 1000px container
export const ProductCardLoadingPreviewImg = styled(WineCardPreviewImg)`
  cursor: default;
  background-color: #dcdcdcdc;
  padding-top: 8.5%;
  padding-bottom: 8.5%;
  ${breakpoints.xsDown} {
    min-height: 0px;
    object-fit: contain;
  }
`;

const ProductNamePlaceholderContainer = styled.div`
  width: 80%;
  height: 1.5em;
  border-radius: 1rem;
`;

export const ProductNamePlaceholder = () => (
  <ProductNamePlaceholderContainer>
    <AnimatedBackground gradientStart="#C0C0C0" gradientFinish="#DDDDDD" borderRadius="1rem" />
  </ProductNamePlaceholderContainer>
);

export const ProductTagPlaceholderContainer = styled.div<{
  width: string;
}>`
  width: ${(props) => props.width};
  height: 20px;
  margin: 0px 5px 8px 0px;
  border-radius: 1rem;
`;

export const ProductTagPlaceholder = ({ width }: { width: string }) => (
  <ProductTagPlaceholderContainer width={width}>
    <AnimatedBackground gradientStart="#DCDCDCDC" gradientFinish="#F2F2F2" borderRadius="1rem" />
  </ProductTagPlaceholderContainer>
);

export const ButtonPlaceholderContainer = styled.div`
  cursor: default;
  height: 35px;
  width: 45px;
  ${breakpoints.mdDown} {
    /* iPad and lower */
    height: 33px;
  }
`;

export const ButtonPlaceholder = () => (
  <ButtonPlaceholderContainer>
    <AnimatedBackground gradientStart="#696969" gradientFinish="#8D8D8D" borderRadius="0px" />
  </ButtonPlaceholderContainer>
);
